import Script from "next/script";

const PushEngageScript = () => {
  const appId = process.env.NEXT_PUBLIC_VAR_ENV === "production"
    ? "788eebd5-805f-46b0-9f09-0fa533667cc9"
    : "a03d2da9-b16f-443c-bdb6-2f924843f32f";

  return (
    <Script
      id="pushengage-sdk"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          (function(w, d) {
            if (w.PushEngage && w.PushEngage._initialized) return;
            w.PushEngage = w.PushEngage || [];
            w._peq = w._peq || [];
            w.PushEngage._initialized = true;

            PushEngage.push(['init', { appId: '${appId}' }]);
            var e = d.createElement('script');
            e.src = 'https://clientcdn.pushengage.com/sdks/pushengage-web-sdk.js';
            e.async = true;
            e.type = 'text/javascript';
            d.head.appendChild(e);
          })(window, document);
        `,
      }}
    />
  );
};

export default PushEngageScript;
